import React from 'react'
import AppRouter from "./routes/index";
import { Toaster } from 'react-hot-toast';

import { Provider } from 'react-redux';
import configureStore from './store/';
import { LateralMenuProvider } from './hooks/useLateralMenu';
import { ThemeModeProvider } from './hooks/useThemeMode';
import './styles/semantic-buttons-fix';

import './styles/index.css';
import './styles/index.scss';
import './styles/menu.css'
import './styles/menu.scss'
import './styles/theme.css'
import './styles/components/ModuleControlsTheme.css'
import './routes/payroll/PayrollTheme.css'
import './routes/condicion de pagos/PaymentConditionTheme.css'
import './routes/mantenimientos/ClientsCatalogTheme.css'
import './routes/mantenimientos/SuppliersTheme.css'
import './routes/mantenimientos/EmployeesTheme.css'

const store = configureStore();

function App() {
  return (
    <ThemeModeProvider>
      <Provider store={store}>
        <LateralMenuProvider>
          <div className="app-root">
            <AppRouter />
            <Toaster
              position="top-right"
              reverseOrder={true}
              toastOptions={{
                style: {
                  background: 'var(--theme-toast-bg)',
                  color: 'var(--theme-toast-text)',
                  border: '1px solid var(--theme-toast-border)',
                  boxShadow: 'var(--theme-toast-shadow)',
                },
              }}
            />
          </div>
        </LateralMenuProvider>
      </Provider>
    </ThemeModeProvider>
  );
}

export default App;
